import { render, staticRenderFns } from "./contract-on-us.vue?vue&type=template&id=08e0c844&scoped=true"
import script from "./contract-on-us.vue?vue&type=script&lang=js"
export * from "./contract-on-us.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=08e0c844&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e0c844",
  null
  
)

export default component.exports